// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Nm4k0zIxuYQxKPW_L3t0{cursor:pointer;border:1px solid var(--interaction-neutral-normal);width:-webkit-fit-content;width:fit-content;color:var(--content-primary-primary);background:0 0;border-radius:6px;align-items:center;gap:4px;padding:9px 16px 9px 12px;display:flex}.Nm4k0zIxuYQxKPW_L3t0:hover{border:1px solid var(--interaction-neutral-hovered)}.Nm4k0zIxuYQxKPW_L3t0.M6NbhJDPfN0RQT4U6Etg{border:1px solid var(--border-brand-default);background:var(--light-blue-10);color:var(--content-primary-primary)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"option": `Nm4k0zIxuYQxKPW_L3t0`,
	"selected": `M6NbhJDPfN0RQT4U6Etg`
};
export default ___CSS_LOADER_EXPORT___;
